import { render, staticRenderFns } from "./ComprasDiretasEmElaboracao.vue?vue&type=template&id=fc7dd1c8"
import script from "./ComprasDiretasEmElaboracao.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasEmElaboracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports